import Vue, { CreateElement } from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ClickOutside from 'vue-click-outside'

import { Button } from '@src/elements/button/button'
import './manage-categories.sass'
import Category from '@src/data/category'
import { CategoryService } from '@src/service/category'
import { Subtitle1 } from '@src/elements/typography/typography'
import { Checkbox } from '@src/elements/input/checkbox'
import './select-categories.sass'
import { noop } from 'vue-class-component/lib/util'
import { Loader } from '@src/components/loading-screen/loader/loader'
import ManageCategories from '@src/routes/content/components/categories/manage-categories'
import { Icon } from '@src/elements/icon/icon'
import { API } from '@src/lib/api_path'
import ApiClient from '@src/lib/api_client'
import WorkoutData from '@src/data/workout-data'
import SessionManager from '@src/lib/session_manager'

@Component({
  directives: {
    ClickOutside
  },
  computed: {
    locale () {
      return this.$store.state.i18n.locale || 'en-gb'
    },
    workoutCategories: {
      get () {
        return this.$store.state.new_workout.categories || []
      },
      set (categories: number[]) {
        this.$store.state.new_workout.categories = categories
      }
    }
  }
})
export default class SelectCategories extends Vue {

  @Prop({ required: false, default: noop })
  closeCallback: () => void

  // if present then it was opened from workout list
  @Prop({ required: false, default: null })
  workout: WorkoutData

  protected workoutCategories: number[]
  protected categories: Category[] = []
  protected apiClient: ApiClient
  private loading: boolean = true
  private locale: string
  private selectedCategories: number[]
  private showManageCategories: boolean = false

  constructor () {
    super()
    this.apiClient = new ApiClient()
  }
  created () {
    this.selectedCategories = this.workout ? Array.from(this.workout.categories) : Array.from(this.workoutCategories)
    return this.loadCategories()
  }

  close () {
    if (this.closeCallback) {
      this.closeCallback()
    }
  }

  loadCategories () {
    return new CategoryService().getCategories(SessionManager.Instance.isMasterClub(), this.locale)
      .then(categories => this.categories = categories)
      .finally(() => this.loading = false)
  }

  render (h: CreateElement) {
    return <div class={`categories-content ${this.workout ? 'categories-content-workout-card' : '' }`} v-click-outside={this.close}>
      <Subtitle1 class={'categories-title'}>{this.$t('PAGE.CONTENT.WORKOUTS.CATEGORIES.ADD_CATEGORIES')}</Subtitle1>
      <div class={'categories-scrollable'}>
        {this.loading ? <Loader/> : this.categories.map((category) =>
          <div class={'category-row'} key={category.id} onClick={() => this.selectCategory(category.id)}>
            {SessionManager.Instance.isMasterClub() ? <Icon name='workout/certified' /> : ''}
            <Subtitle1 >{category.getName(this.locale)}</Subtitle1>
            <Checkbox value={this.selectedCategories.includes(category.id)} change={() => this.selectCategory(category.id)}/>
          </div>)
        }
      </div>
      <div class={'footer'}>
        <Button type='remove' class='save-btn' label={this.$t('SAVE')} click={this.addCategories} />
        {!this.workout ? <Button type='elevated' class='manage-btn' label={this.$t('PAGE.CONTENT.WORKOUTS.CATEGORIES.MANAGE')} click={this.invertShowManageCategories} /> : ''}
      </div>
      {this.showManageCategories ? <ManageCategories show={true} closeCallback={this.invertShowManageCategories}/> : ''}
    </div>
  }

  async addCategories () {
    if (this.workout) {
      let api = API.TRAINERS_API.WORKOUT_CATEGORIES.replace('{workoutId}', `${this.workout.id}`)
      await this.apiClient.post(api, { workout: { categories: this.selectedCategories } })
        .then(() => {
          this.workout.categories = this.selectedCategories
          this.$store.dispatch('showToast', { message: this.$t('PAGE.CONTENT.WORKOUTS.CATEGORIES.ADD_SUCCESS'), fadeOut: true })
          return Promise.resolve()
        })
        .catch(error => {
          console.log('cannot edit workout', error)
          return Promise.reject(error)
        })
    } else {
      this.workoutCategories = this.selectedCategories
    }
    this.close()
  }

  private selectCategory (categoryId) {
    let index = this.selectedCategories.indexOf(categoryId)
    if (index >= 0) {
      this.selectedCategories.splice(index, 1)
    } else {
      this.selectedCategories.push(categoryId)
    }
    this.$forceUpdate()
  }

  private invertShowManageCategories () {
    this.showManageCategories = !this.showManageCategories
    if (!this.showManageCategories) {
      return this.loadCategories()
    }
  }

}
